import { ITextureStyle } from "./ITextureStyle";

export interface ITextureDrawable {
  textureStyle: ITextureStyle;
}

export function instanceOfITextureDrawable(instance: any): instance is ITextureStyle {
  return instance
      && (instance.textureStyle !== undefined);
}
